<script>
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import VehicleEfficiencyTable from "./VehicleEfficiencyTable.svelte";
	import client from "../../../../services/client";
	import WarningModal from "../../../../components/CustomModal/WarningModal.svelte";
	import {
		errorMessage,
		loading,
		totalPages,
		loadingStatus,
		masterData,
		warningModalOpen,
		sizeSelect,
		initPage,
	} from "../../../../store/store";

	import {
		Button,
		Col,
		Row,
		Modal,
		ModalBody,
		ModalHeader,
		Progress,
	} from "sveltestrap";
	import Swal from "sweetalert2";
	import { tweened } from "svelte/motion";
	import { cubicOut } from "svelte/easing";
	import { form, field } from "svelte-forms";
	import { afterUpdate, onMount } from "svelte";
	import { required } from "svelte-forms/validators";
	import { extractErrorMessage } from "../../../../utils/misc";
	import ErrorMessageHandler from "../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import CustomSelect from "../../../../components/CustomSelect/CustomSelect.svelte";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";
	import { cachedMasterData } from "src/services/profile";

	let data = [];

	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});

	$: queryParams = `?page=1&size=${$sizeSelect}`;
	let searchParams = window.location.search.toString();

	let queryPage = searchParams.includes("page");

	$: if (queryPage) {
		queryParams = `?page=${params.page}&size=${$sizeSelect}`;
		initPage.set(+params.page);
	}
	$: if (!queryPage) {
		initPage.set(1);
	}

	const fetchEfficiencyRates = async () => {
		try {
			loading.set(true);
			const res = await client(`/v1/fuel/efficiencyRate${queryParams}`, {
				method: "GET",
				version: "Vehicle",
			});
			data = res.data.dataList;
			totalPages.set(res.data.totalPage);
			loading.set(false);
		} catch (err) {
			loading.set(false);
			extractErrorMessage(err);
		}
	};

	onMount(async () => {
		await fetchEfficiencyRates();
		await cachedMasterData();
	});

	const refreshData = async (type) => {
		try {
			if (type == "delete") {
				loading.set(true);
			} else {
				warningModalOpen.set(false);
				loadingStatus.set(true);
			}
			const res = await client(`/v1/fuel/efficiencyRate${queryParams}`, {
				method: "GET",
				version: "Vehicle",
			});
			data = res.data.dataList;
			totalPages.set(res.data.totalPage);
			if (type == "delete") {
				loading.set(false);
			} else {
				warningModalOpen.set(false);
				loadingStatus.set(false);
			}
		} catch (err) {
			if (type == "delete") {
				loading.set(false);
			} else {
				loadingStatus.set(false);
			}
			extractErrorMessage(err);
		}
	};

	let efficiencyError;
	let maxDistanceError;
	let capacityError;
	let evOpen = false;
	let fileSize = 0;
	$: progressStatus = "";

	let progress = tweened(10, {
		delay: 0,
		duration: 5000,
		easing: cubicOut,
	});

	$: fuelName =
		$masterData.fuelTypes?.find((fuel) => fuel.id === $fuelType.value)
			?.name ?? undefined;

	const carModel = field("carModel", "", [required()]);
	const carMake = field("carMake", "", [required()]);
	const fuelType = field("fuelType", "", [required()]);
	const evMaxDistanceKm = field("evMaxDistanceKm", "", [required()]);
	const efficiency = field("efficiency", "", [required()]);
	const capacity = field("capacity", "", [required()]);
	const myForm = form(
		carMake,
		carModel,
		fuelType,
		capacity,
		efficiency,
		evMaxDistanceKm
	);

	let makeName;
	let modelName;
	let fuelName;

	const getName = () => {
		const selectedCarModel = $masterData.vehicleModels.find(
			(model) => model.id === $carModel.value
		);
		const selectedCarMake = $masterData.vehicleMakes.find(
			(model) => model.id === $carMake.value
		);
		const selectedFuelType = $masterData.fuelTypes.find(
			(model) => model.id === $fuelType.value
		);
		modelName = selectedCarModel ? selectedCarModel.name : "";
		makeName = selectedCarMake ? selectedCarMake.name : "";
		fuelName = selectedFuelType ? selectedFuelType.name : "";
	};

	function loadEFficiencyProgress(progressNo, fileName) {
		$progress += progressNo;
		progressStatus =
			"Importing EFficiency CSV from " + fileName + " file...";
	}

	let load = false;
	const handleSubmit = async () => {
		// fuelId 3 = electric
		// /api/evCharging/v1/efficiencyRate

		// fuelId !== 3
		// /api/vehicle/v1/fuel
		let endpoint = {};
		let data = {
			vehicleModelId: $carModel.value,
			vehicleMakeId: $carMake.value,
		};

		const electricEndpoint = {
			url: "/v1/efficiencyRate",
			service: "evCharging",
		};

		const fuelEndpoint = {
			url: "/v1/fuel",
			service: "Vehicle",
		};

		if (fuelName === "Electric") {
			endpoint = electricEndpoint;
			data.capacity = $capacity.value;
			data.efficiency = $efficiency.value;
			data.evMaxDistanceKm = $evMaxDistanceKm.value;
			data.vehicleFuelId = $fuelType.value;
		} else {
			endpoint = fuelEndpoint;
			data.fuelTankSize = $capacity.value;
			data.fuelConsumption = $efficiency.value;
			data.fuelTypeId = $fuelType.value;
		}
		getName();

		try {
			load = true;
			loading.set(true);
			const res = await client(endpoint.url, {
				method: "POST",
				version: endpoint.service,
				data,
			});

			if (res.status === 200) {
				if (res.data.code === 400) {
					extractErrorMessage(res.data.message);

					document
						.getElementsByClassName("content-container")[0]
						.scrollTo(0, 0);
				} else {
					warningModalOpen.set(true);
					carMake.clear();
					carModel.clear();
					fuelType.clear();
					capacity.clear();
					efficiency.clear();
					evMaxDistanceKm.clear();
				}
				loading.set(false);
				load = false;
				window.scrollTo(0, 0);
				return;
			}
		} catch (error) {
			extractErrorMessage(error);
			load = false;
			loading.set(false);
		}
	};

	let idStatus;
	async function handleStatusChange(id, status, fuelId, fuelName) {
		// FuelType "Electric": PUT /api/evCharging/v1/efficiencyRate/status
		// All other FuelType: PUT /api/vehicle/v1/fuel/status

		let endpoint = {};
		let data = {
			id,
		};

		const electricEndpoint = {
			url: "/v1/efficiencyRate/status",
			service: "evCharging",
		};

		const fuelEndpoint = {
			url: "/v1/fuel/status",
			service: "Vehicle",
		};

		if (fuelName === "Electric") {
			endpoint = electricEndpoint;
			data.status = status ? 1 : 0;
		} else {
			endpoint = fuelEndpoint;
			data.status = Boolean(status);
		}
		idStatus = id;
		try {
			loadingStatus.set(true);
			const res = await client(endpoint.url, {
				method: "PUT",
				version: endpoint.service,
				data,
			});
			if (res.status === 200) {
				loadingStatus.set(false);
				refreshData();
			}
		} catch (err) {
			extractErrorMessage(err);
			loadingStatus.set(false);
		}
	}

	async function handleDelete(id, fuelId, fuelName) {
		// FuelType "Electric": DELETE /api/evCharging/v1/efficiencyRate/{id}
		// All other FuelType: DELETE /api/vehicle/v1/fuel/{vehicleFuelId}

		let endpoint = {};

		const electricEndpoint = {
			url: `/v1/efficiencyRate/${id}`,
			service: "evCharging",
		};

		const fuelEndpoint = {
			url: `/v1/fuel/${id}`,
			service: "Vehicle",
		};

		if (fuelName === "Electric") {
			endpoint = electricEndpoint;
		} else {
			endpoint = fuelEndpoint;
		}
		idStatus = id;
		try {
			loadingStatus.set(true);
			const res = await client(endpoint.url, {
				method: "DELETE",
				version: endpoint.service,
			});
			if (res.status === 200) {
				refreshData("delete");
			}

			// loading.set(false);
		} catch (err) {
			extractErrorMessage(err);
			loadingStatus.set(false);
		}
	}

	let files;
	async function handleImport(e) {
		Swal.fire({
			title: `Do you want to upload this file <b class="link-text mt-2 fs-3">${e.target.files[0].name}</b>?`,
			showDenyButton: true,
			confirmButtonText: "<b>OK</b>",
			denyButtonText: `Don't upload`,
			confirmButtonColor: "#19F9B9",
			customClass: {
				confirmButton: "primary", //insert class here
			},
		}).then((result) => {
			/* Read more about isConfirmed, isDenied below */
			if (result.isConfirmed) {
				evOpen = true;
				loadEFficiencyProgress(60, e.target.files[0].name);
				const dataArray = new FormData();
				dataArray.append("csvfile", e.target.files[0]);
				client("/v1/efficiencyRate/csvFileImport", {
					method: "POST",
					version: "evCharging",
					header: "multipart",
					data: dataArray,
				})
					.then((res) => {
						evOpen = false;
						if (
							res.status == 200 &&
							res.data.data.totalSuccess === 0
						) {
							extractErrorMessage(res.data.data.message);
							Swal.fire({
								icon: "error",
								title: "Ooops!",
								text: res.data?.data?.message,
							});

							files = "";
							e.target.value = "";
						} else if (
							res.status == 200 &&
							res.data.data.totalSuccess !== 0
						) {
							Swal.fire({
								icon: "success",
								title: "Success!",
								text: `Vehicle Efficiency rate were imported`,
							}).then((res) => {
								window.location.reload();
							});
							files = "";
							e.target.value = "";
						}
					})
					.catch((err) => {
						Swal.fire({
							icon: "error",
							title: "Oops...",
							text: "Something went wrong!",
						});
						// window.location.reload();
						files = "";
						e.target.value = "";
					});
			} else if (result.isDenied) {
				Swal.fire({
					text: "Changes are not saved",
					icon: "info",
					confirmButtonColor: "#19F9B9",
					customClass: {
						confirmButton: "primary", //insert class here
					},
				});
				e.target.value = "";
			}
		});
	}
	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
</script>

<Row>
	<ErrorMessageHandler message={err} />
	<Col xs={6}>
		<Col xs={12}>
			<div>
				<Col className="row d-flex align-items-start mx-0">
					<PageHeader title="Vehicle Efficiency" />
				</Col>
			</div>
		</Col>
		<Col xs={12} class="my-3">
			<div>
				<h5><b>Add Vehicle Efficiency</b></h5>
			</div>
			<div>
				<p><span class="redStar">*</span> Mandatory fields</p>
			</div>
		</Col>
		<Col>
			<Row>
				<Col>
					<label for="priority" class="d-block pt-2 mb-2">
						<span>
							Vehicle Model<span class="redStar">*</span>
						</span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={6}>
					<CustomSelect
						type="text"
						bind:value={$carModel.value}
						options={$masterData.vehicleModels}
						error={$myForm.hasError("carModel.required")}
						errorText="Vehicle model is required"
						defaultOption="Select Vehicle Model"
					/>
				</Col>
			</Row>
		</Col>
		<Col>
			<Row>
				<Col>
					<label for="priority" class="d-block pt-2 mb-2">
						<span>
							Vehicle Make<span class="redStar">*</span>
						</span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={6}>
					<CustomSelect
						type="text"
						bind:value={$carMake.value}
						options={$masterData.vehicleMakes}
						error={$myForm.hasError("carMake.required")}
						errorText="Vehicle make is required"
						defaultOption="Select Vehicle Make"
					/>
				</Col>
			</Row>
		</Col>
		<Col>
			<Row>
				<Col>
					<label for="priority" class="d-block pt-2 mb-2">
						<span> Fuel Type<span class="redStar">*</span> </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={6}>
					<CustomSelect
						type="text"
						bind:value={$fuelType.value}
						options={$masterData.fuelTypes}
						error={$myForm.hasError("fuelType.required")}
						errorText="Fuel type is required"
						defaultOption="Select Fuel Type"
					/>
				</Col>
			</Row>
		</Col>
		<Row>
			<Col>
				<Row>
					<Col>
						<label for="mobile" class="d-block my-2">
							<span>
								Fuel (L)/Battery Capacity (kWh)<span
									class="redStar">*</span
								>
							</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<CustomInput
							type="number"
							min="0"
							bind:value={$capacity.value}
							error={$myForm.hasError("capacity.required") ||
								capacityError}
							errorText={$myForm.hasError("capacity.required")
								? "Fuel (L)/Battery Capacity (kWh) is required"
								: capacityError
								? capacityError
								: ""}
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="mobile" class="d-block my-2">
							<span>
								Fuel/Battery Efficiency (km)<span
									class="redStar">*</span
								>
							</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<CustomInput
							type="number"
							min="0"
							bind:value={$efficiency.value}
							error={$myForm.hasError("efficiency.required") ||
								efficiencyError}
							errorText={$myForm.hasError("efficiency.required")
								? "Fuel/Battery Efficiency is required"
								: efficiencyError
								? efficiencyError
								: ""}
						/>
					</Col>
				</Row>
			</Col>
		</Row>
		{#if fuelName === "Electric"}
			<Col>
				<Row>
					<Col>
						<label for="mobile" class="d-block my-2">
							<span> EV max. distance (km) </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomInput
							type="number"
							min="0"
							bind:value={$evMaxDistanceKm.value}
							error={$myForm.hasError(
								"evMaxDistanceKm.required"
							) || maxDistanceError}
							errorText={$myForm.hasError(
								"evMaxDistanceKm.required"
							)
								? "EV max. distance is required"
								: maxDistanceError
								? maxDistanceError
								: ""}
						/>
					</Col>
					<Col class="d-flex justify-content-start" xs={6}>
						<div class="mx-4 my-1">
							<Button
								class="themeButton primary px-2"
								block
								disabled={!$carModel.value ||
									!$carMake.value ||
									!$capacity.value ||
									!$efficiency.value ||
									!$evMaxDistanceKm.value}
								on:click={myForm.validate}
								on:click={() => handleSubmit()}
							>
								{#if load}
									<span
										class="spinner-grow spinner-grow-sm"
										role="status"
										aria-hidden="true"
									/> Loading ...
								{:else}
									Add
								{/if}
							</Button>
						</div>
					</Col>
				</Row>
			</Col>
		{:else}
			<Col class="d-flex justify-content-start" xs={6}>
				<div class="mt-2">
					<Button
						class="themeButton primary px-2"
						block
						disabled={!$carModel.value ||
							!$carMake.value ||
							!$capacity.value ||
							!$efficiency.value}
						on:click={myForm.validate}
						on:click={() => handleSubmit()}
					>
						{#if load}
							<span
								class="spinner-grow spinner-grow-sm"
								role="status"
								aria-hidden="true"
							/> Loading ...
						{:else}
							Add
						{/if}
					</Button>
				</div>
			</Col>
		{/if}
	</Col>
	<Col class="d-flex justify-content-end" xs={6}>
		<div class="mx-4">
			<input
				id="fileInput"
				type="file"
				multiple={false}
				hidden="hidden"
				on:change={(e) => handleImport(e)}
			/>
			<label
				type="button"
				for="fileInput"
				id="customButton"
				class="btn themeButton primary px-4 d-flex justify-content-center"
				block>Import CSV</label
			>
			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<p>
				<a
					href="/assets/csv/ImportEfficiencyRate.csv"
					target="_blank"
					download="EfficiencyRate_template.csv"
					rel="noreferrer"
					class="link link-text"
				>
					Download CSV Template
				</a>
			</p>
		</div>
	</Col>
	<!-- <Col xs={12} class="mt-4">
        <div class="line mt-4" />
    </Col> -->

	<Col class="my-5">
		<VehicleEfficiencyTable
			{data}
			{handleStatusChange}
			{idStatus}
			{handleDelete}
		/>
	</Col>
	<WarningModal onClose={refreshData} carEfficiency={true} />
</Row>

<Modal isOpen={evOpen} size="lg" class="modal-dialog modal-dialog-centered">
	<ModalHeader>Importing EV Jobs</ModalHeader>
	<ModalBody>
		<p class="d-flex justify-content-center"><b>{progressStatus}</b></p>
		<Progress
			aria-valuemax={fileSize}
			value={$progress}
			color={progress >= 100 ? "success" : "primary"}
		/>
	</ModalBody>
</Modal>

<!-- <style>
	.line {
		width: 100%;
		border: 1px solid #f0eaea;
		display: inline-block;
	}
</style> -->

<style>
	.redStar {
		color: red;
	}

	input[type="number"]::-webkit-inner-spin-button,
	input[type="number"]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	input[type="number"] {
		-moz-appearance: textfield;
		appearance: textfield;
	}
</style>
